import { getDb } from "./core";
import type { ContactRow } from "./types";

export async function upsertContact(c: ContactRow): Promise<void> {
  const db = await getDb();
  await db.put("contacts", c);
}

/** Drop local contacts missing from the server snapshot (full list from auth / contacts.list). */
export async function syncContactsFromServer(serverContacts: ContactRow[]): Promise<void> {
  const db = await getDb();
  const serverIds = new Set(serverContacts.map((c) => c.user_id));
  const keys = await db.getAllKeys("contacts");
  const tx = db.transaction("contacts", "readwrite");
  for (const key of keys) {
    const id = String(key);
    if (!serverIds.has(id)) {
      await tx.store.delete(id);
    }
  }
  for (const c of serverContacts) {
    await tx.store.put(c);
  }
  await tx.done;
}

export async function listContacts(): Promise<ContactRow[]> {
  const db = await getDb();
  return db.getAll("contacts");
}

export async function getContact(userId: string): Promise<ContactRow | undefined> {
  const db = await getDb();
  return db.get("contacts", userId);
}

export async function removeContact(userId: string): Promise<void> {
  const db = await getDb();
  await db.delete("contacts", userId);
}
